import React, { useState } from "react";
import { Tab, Tabs, Alert } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import WorkspacePage from "../../../components/WorkspacePage";
import ActionItemsTab from "./ActionItemsTab";
import FutureTab from "./FutureTab";
import CompleteDashboardTab from "./CompleteDashboardTab";

const FollowUpDashboard = () => {
  const [currentTab, setCurrentTab] = useState("actions");
  const [globalError, setGlobalError] = useState("");

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    setGlobalError("");
  };

  return (
    <WorkspacePage>
      <PageHeader 
        title="Follow-Up Management" 
        tabs={
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            // data-tour-id="tour-followup-tabs"
          >
            <Tab value="actions" label="Action Items" />
            <Tab value="future" label="Future" />
            <Tab value="dashboard" label="Complete Dashboard" />
          </Tabs>
        }
      />


      {globalError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {globalError}
        </Alert>
      )}

      {currentTab === "actions" && <ActionItemsTab setError={setGlobalError} />}
      {currentTab === "future" && <FutureTab setError={setGlobalError} />}
      {currentTab === "dashboard" && <CompleteDashboardTab setError={setGlobalError} />}
    </WorkspacePage>
  );
};

export default FollowUpDashboard;
